import {Component, inject, OnInit, ChangeDetectionStrategy} from "@angular/core";
import ModalService, {ModalRef} from "../../../shared-module/services/modal.service";
import {AuthService} from "../../../shared-module/services/auth.service";
import RelationContactStore from "../../../shared-module/services/Stores/relation-contact.store";
import {FormGroup} from "@angular/forms";
import RelationContact from "../../../shared-module/model/relation-contact.model";
import {HttpErrorResponse} from "@angular/common/http";
import {SuccessModalComponent} from "../../../shared-module/components/success-modal/success-modal.component";

interface ErrorResponse {
  error: {
    errors: Record<string, string>;
  }
}

@Component({
    selector: 'app-abstract-my-account-update-modal',
    changeDetection: ChangeDetectionStrategy.Eager,
    template: '',
    
})
export default abstract class AbstractMyAccountDialogComponent implements OnInit {
  public user: RelationContact | null = null;
  public isSubmitted: boolean = false;

  public abstract form: FormGroup;
  public abstract successMessage: string;

  protected authService: AuthService;
  protected modalRef: ModalRef<AbstractMyAccountDialogComponent>;
  protected userStore: RelationContactStore;
  protected modalService: ModalService;

  constructor() {
    this.authService = inject(AuthService);
    this.modalRef = inject(ModalRef);
    this.userStore = inject(RelationContactStore);
    this.modalService = inject(ModalService);
  }

  public ngOnInit(): void {
    this.authService.getUser().subscribe((user: RelationContact | null) => {
      this.user = user;
    });
  }

  public submit(): void {
    this.isSubmitted = true;

    if (this.form.invalid || !this.user) {
      return;
    }

    //clone the current user
    const currentUserClone: RelationContact = {...this.user} as RelationContact;

    //set all fields to the new values
    const formFields: string[] = Object.keys(this.form.value);
    formFields.forEach((field: string): void => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      currentUserClone[field] = this.form.value[field];
    });

    this.userStore.update(currentUserClone).subscribe({
      next: (): void => {
        //update the user with the new values
        //this will trigger the whole app to
        //show the new values
        this.user = {
          ...this.user,
          ...currentUserClone,
        } as RelationContact;

        this.authService.isLoggedIn(true).subscribe(() => {
          this.modalRef.close(this.form.value);
          this.modalService.open(SuccessModalComponent, null, {
            title: 'Gelukt!',
            subtitle: this.successMessage,
            width: '500px',
            showCloseButton: true,
          });
        });
      },
      error: (response: HttpErrorResponse & ErrorResponse): void => {
        this.form.setErrors(null);
        response.error.errors.forEach((error: {field: string, message: string}) => {
          const fieldName: string = error.field.replace('data.', '');
          this.form.get(fieldName)?.setErrors({[error.message]: true});
        });
      }
    });
  }
}
